import type { Module } from 'vuex';
import { LanguageGroupItem } from '@/types/LanguageGroupItem';
import {RootState} from "@/store";

export interface LanguageGroupItemState {
  languageGroupItem: LanguageGroupItem | null;
  deleted: boolean;
}

const languageGroupItemModule: Module<LanguageGroupItemState, RootState> = {
  namespaced: true,

  state: (): LanguageGroupItemState => ({
    languageGroupItem: null,
    deleted: false,
  }),

  mutations: {
    setLanguageGroupItem(state, payload: any) {
      if (payload === null || payload === undefined) {
        state.languageGroupItem = null;
        state.deleted = false;
        return;
      }
      state.languageGroupItem = LanguageGroupItem.fromRaw(payload);
      state.deleted = false;
    },

    setLanguageGroupItemDelete(state, payload: { idLanguageGroupItem: number }) {
      if (state.languageGroupItem?.idLanguageGroupItem === payload.idLanguageGroupItem) {
        state.deleted = true;
      }
    },

    clearLanguageGroupItem(state) {
      state.languageGroupItem = null;
      state.deleted = false;
    },
  },

  actions: {
    wsSetLanguageGroupItem({ commit }, payload) {
      commit('setLanguageGroupItem', payload);
    },

    wsSetEmptyLanguageGroupItem({ commit }) {
      commit('setLanguageGroupItem', null);
    },

    wsLanguageGroupItemDelete({ commit }, payload) {
      commit('setLanguageGroupItemDelete', payload);
    },

    clearLanguageGroupItem({ commit }) {
      commit('clearLanguageGroupItem');
    },
  },
};

export default languageGroupItemModule;
